import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledTitleTypography = styled(Typography)({
  lineHeight: 1.33,
  marginBottom: 10
});

export default StyledTitleTypography;
